import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import _isEqual from 'lodash/isEqual'
import './style.scss'

class Tabs extends PureComponent {
  constructor (props) {
    super(props)
  }

  edit () {
    alert("asdfasdf")
  }

  render () {

    console.log(this.props.tabs)

    let openDocs = this.props.tabs.filter(n => true).map((item, index) => {
      return (
        <li key={index} className={this.props.active === index ? 'active' : ''}>
          <a style={{background: this.props.colors[index]}} onClick={this.props.action.bind(this, index)}>{item}</a>
          <span className='glyphicon glyphicon-remove remove' />
        </li>
      )
    })

    return (
      <div className='tabs'>
        <ul>
          {openDocs}
          <li onClick={this.props.newTab}>
            <a style={{background: 'purple'}}><span className='glyphicon glyphicon-plus add' /></a>
          </li>
        </ul>
      </div>
    )
  }
}


export default Tabs



// WEBPACK FOOTER //
// ./src/views/components/Tabs/index.js